import * as React from 'react';

/**
 *  Fixes - useCallback() invalidates too often in practice
 *  Context - https://github.com/facebook/react/issues/14099
 *
 *  This hook helps to avoid usage of useCallback when passing functions to child
 *  components
 */
export function useStableCallback<T extends (...args: any[]) => any>(fn: T): T {
    const ref = React.useRef<T>();

    React.useLayoutEffect(() => {
        ref.current = fn;
    });

    return React.useCallback((...args: Parameters<T>) => ref.current(...args), []) as T;
}
